import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Drawer from '../Common/Drawer/Drawer';
import Toggle from '../Common/Toggle/Toggle';

export class BaselineTaskListColumnDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false
        }
    }


    onFormChange = (name, value) => {
        this.props.onColumnToggle(name, value);
    }

    columnIsActive = (column) => {
        if(this.props.columns.findIndex(m => m.header === column.label) === -1){
            return false;
        } else {
            return true;
        }
    }

    render() {

        return (
            <Drawer isWide={false} title="Columns"
                cancelText="Close"
                onCancelClick={this.props.onComplete}>

                {this.props.columnOptions.map(column => 
                    <div key={column.label}>
                        <Toggle 
                            name={column.value.field} 
                            text={column.label}
                            checked={this.columnIsActive(column)}
                            onChange={this.onFormChange} />
                    </div>
                )}
            </Drawer>
        )
    }
}

BaselineTaskListColumnDrawer.propTypes = {
    onComplete: PropTypes.func.isRequired,
    onColumnToggle: PropTypes.func.isRequired,
    columnOptions: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired
};

export default BaselineTaskListColumnDrawer;
